import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { FC, ReactNode } from "react";
import { BaseDialogProps } from "../../contexts/dialogManager";

export interface GenericDialogProps extends BaseDialogProps {
  title?: string;
  actions?: ReactNode;
  maxWidth?: "sm" | "md" | "lg" | "xl";
  fullWidth?: boolean;
}

const GenericDialog: FC<GenericDialogProps> = ({
  open,
  onClose,
  title,
  actions = null,
  children,
  ...rest
}) => (
  <Dialog open={open} onClose={onClose} {...rest}>
    {title ? <DialogTitle>{title}</DialogTitle> : null}
    <DialogContent>{children}</DialogContent>
    <DialogActions>{actions}</DialogActions>
  </Dialog>
);

export { GenericDialog };
